module.exports = __webpack_public_path__ + "img/background3.7e895cd8.jpg";